import ContentManagement from "./ContentManagement.jsx"

export default ContentManagement;